import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'age gregorien precise";
const DESCRIPTION =
  "Calculez votre age exact a partir de votre date de naissance: annees, mois, jours, semaines et heures. Ideal pour les demarches, dossiers et suivis personnels.";
const KEYWORDS =
  "calculatrice age, age exact, date de naissance, age en jours, age gregorien, calcul d'age en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/agegregorian/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Calculatrice d'Âge Grégorien",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Toutes les Calculatrices",
        item: "https://do-calculate.com/fr/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Calculatrice d'Âge Grégorien",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Qu'est-ce que l'âge grégorien?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "L'âge grégorien est la méthode utilisée pour mesurer l'âge d'une personne en fonction de sa date de naissance selon le calendrier grégorien.",
        },
      },
      {
        "@type": "Question",
        name: "Comment puis-je calculer mon âge grégorien?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Vous pouvez calculer votre âge grégorien en saisissant votre date de naissance dans la calculatrice, qui calculera automatiquement votre âge en années, mois, jours et heures avec précision.",
        },
      },
      {
        "@type": "Question",
        name: "Comment utiliser cette calculatrice d'âge?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Entrez votre date de naissance dans les champs jour, mois et année, puis cliquez sur le bouton Calculer pour obtenir votre âge détaillé.",
        },
      },
    ],
  },
];
const DAYS_OF_WEEK = [
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];
const GREGORIAN_MONTHS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

function AgeCalculatorGregorian() {
  // 1. تعريف الحالة للقوائم المنسدلة
  const [birthDateInput, setBirthDateInput] = useState({
    day: "1",
    month: "1",
    year: "1990"
  });

  const [ageResult, setAgeResult] = useState(null);
  const [error, setError] = useState(null);

  const calculateAge = () => {
    const birthDate = new Date(
      parseInt(birthDateInput.year),
      parseInt(birthDateInput.month) - 1,
      parseInt(birthDateInput.day)
    );
    const today = new Date();

    if (isNaN(birthDate.getTime())) {
      setError("Veuillez entrer une date de naissance valide");
      setAgeResult(null);
      return;
    }

    if (birthDate > today) {
      setError("La date de naissance ne peut pas être dans le futur");
      setAgeResult(null);
      return;
    }

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += lastMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = today - birthDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);
    const totalWeeks = Math.floor(totalDays / 7);

    const dayOfWeekName = DAYS_OF_WEEK[birthDate.getDay()];
    const monthName = GREGORIAN_MONTHS[birthDate.getMonth()];

    setAgeResult({
      years,
      months,
      days,
      totalDays,
      totalWeeks,
      totalHours: Math.floor(totalHours % 24),
      totalMinutes: Math.floor(totalMinutes % 60),
      totalSeconds: totalSeconds % 60,
      dayOfWeek: dayOfWeekName,
      monthName: monthName,
      birthDateFormatted: `${dayOfWeekName}, ${birthDate.getDate()} ${monthName} ${birthDate.getFullYear()}`,
    });
    setError(null);
  };

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row p-3">
              <div>
                <p>
                  Cette calculatrice en ligne vous permet de calculer votre âge avec précision en utilisant le calendrier grégorien. Entrez votre date de naissance et la calculatrice affichera automatiquement votre âge en années, mois, jours, heures, minutes et secondes.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle">
              <div className="p-2 mb-4 bg-success text-white text-center">
                <strong>Entrez votre date de naissance</strong>
              </div>

              <div className="mb-4">
                <label><strong>Jour:</strong></label>
                <select
                  className="form-control"
                  value={birthDateInput.day}
                  onChange={(e) => setBirthDateInput({ ...birthDateInput, day: e.target.value })}
                >
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>

              <div className="mb-4">
                <label><strong>Mois:</strong></label>
                <select
                  className="form-control"
                  value={birthDateInput.month}
                  onChange={(e) => setBirthDateInput({ ...birthDateInput, month: e.target.value })}
                >
                  {GREGORIAN_MONTHS.map((m, i) => (
                    <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                  ))}
                </select>
              </div>

              <div className="mb-4">
                <label><strong>Année:</strong></label>
                <select
                  className="form-control"
                  value={birthDateInput.year}
                  onChange={(e) => setBirthDateInput({ ...birthDateInput, year: e.target.value })}
                >
                  {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() - i).map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>

              <div className="text-center mb-4">
                <button
                  className="btn btn-success btn-lg px-5"
                  onClick={calculateAge}
                >
                  Calculer Mon Âge
                </button>
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {ageResult && (
                <div className="alert alert-success mt-4">
                  <h3>Votre Âge:</h3>
                  <div className="mb-3">
                    <strong style={{ fontSize: "24px", color: "#28a745" }}>
                      {ageResult.years} ans, {ageResult.months} mois et {ageResult.days} jours
                    </strong>
                  </div>
                  <div className="mt-3">
                    <p><strong>Détails:</strong></p>
                    <ul>
                      <li>Jour de naissance: {ageResult.dayOfWeek}</li>
                      <li>Date de naissance formatée: {ageResult.birthDateFormatted}</li>
                      <li>Jours totaux: {ageResult.totalDays}</li>
                      <li>Semaines totales: {ageResult.totalWeeks}</li>
                      <li>Heures: {ageResult.totalHours}</li>
                      <li>Minutes: {ageResult.totalMinutes}</li>
                      <li>Secondes: {ageResult.totalSeconds}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Calcul d'age selon le calendrier gregorien</h3></div>
              <div className="info-section-body">
                <p>Le calendrier gregorien est le calendrier civil de reference. Cette page calcule votre age exact entre la date de naissance et aujourd'hui, avec un niveau de detail utile: annees, mois, jours, semaines, heures, minutes et secondes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment calculer son age manuellement</h3></div>
              <div className="info-section-body">
                <p>Soustrayez l'annee de naissance de l'annee en cours, puis retirez 1 si votre anniversaire n'est pas encore passe. Exemple: ne le 15 mars 1990, au 1er janvier 2026, vous avez 35 ans. La conversion en jours reste approximative si on ne tient pas compte des annees bissextiles.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce qu'une annee bissextile ?</h3></div>
              <div className="info-section-body">
                <p>Une annee est bissextile si elle est divisible par 4, sauf les annees divisibles par 100 qui doivent aussi etre divisibles par 400. Ce jour supplementaire (29 fevrier) change le calcul precis de l'age et explique les ecarts observes sur de longues periodes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Calculer l'âge en jours — la précision absolue</div>
              <div className="info-section-body">
                <p>Exprimer l'âge en jours offre une précision sans équivalent :</p>
                <ul>
                  <li>Le jour est une unité de temps fixe, indépendante du système calendaire</li>
                  <li>Il n'est pas affecté par les variations de longueur des mois</li>
                  <li>Particulièrement utile en médecine, en droit et en calculs scientifiques</li>
                </ul>
                <p>Note : à cause des 11 jours de différence annuelle entre calendrier grégorien et hégirien, un écart d'environ 1 an s'accumule toutes les 33 années grégoriennes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Combien de jours avant mon prochain anniversaire ?</div>
              <div className="info-section-body">
                <p>La calculatrice détermine avec précision le nombre exact de jours, d'heures et de minutes restant jusqu'à votre prochain anniversaire.</p>
                <p><strong>Pourquoi c'est utile :</strong></p>
                <ul>
                  <li>Organiser les préparatifs à l'avance (lieu, invitations, gâteau)</li>
                  <li>Partager le compte à rebours avec ses proches</li>
                  <li>Anticiper et savourer l'attente</li>
                  <li>Planifier une surprise pour quelqu'un d'autre</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Utilisations du calcul d'âge dans la vie quotidienne</div>
              <div className="info-section-body">
                <p><strong>Usages personnels :</strong></p>
                <ul>
                  <li>Remplir des formulaires officiels (passeport, mutuelle, contrat)</li>
                  <li>Comparer les âges en famille</li>
                  <li>Vérifier l'éligibilité à une activité (piscine, location de voiture)</li>
                  <li>Planifier sa retraite (années restantes)</li>
                </ul>
                <p><strong>Usages médicaux :</strong></p>
                <ul>
                  <li>Suivi du carnet vaccinal (âge précis en mois)</li>
                  <li>Dosage pédiatrique (médicaments dosés selon l'âge)</li>
                  <li>Calcul de l'âge gestationnel et du terme prévu</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Questions fréquentes</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px" }}><strong>Quelle est la définition de l'âge grégorien ?</strong></h3>
                <p>L'âge grégorien est l'âge calculé selon le calendrier grégorien — le calendrier civil standard utilisé dans la quasi-totalité du monde depuis la réforme du pape Grégoire XIII en 1582.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Pourquoi mon âge en jours est-il si grand ?</strong></h3>
                <p>Chaque année civile comporte environ 365,25 jours. Une personne de 30 ans a vécu environ <strong>10 957 jours</strong> — un chiffre surprenant qui illustre la densité de notre expérience quotidienne.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Le calcul est-il précis si je suis né un 29 février ?</strong></h3>
                <p>Oui, la calculatrice gère correctement les naissances le 29 février. Pour les années non bissextiles, l'anniversaire est conventionnellement compté le 1er mars dans la plupart des systèmes juridiques.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>La calculatrice fonctionne-t-elle sur mobile ?</strong></h3>
                <p>Oui, l'outil est entièrement responsive et fonctionne sur smartphone, tablette et ordinateur.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgeCalculatorGregorian;
